<template>
  <div id="ApprovalProgressIndicator">
    <ul>
      <li :class="{ active: !progress.isActive }" v-for="(progress, index) in progressData" :key="index">
        <div class="state">{{ progress.state }}</div>
        <div>
          <span class="label">{{ progress.role }}</span>
          <span>{{ progress.member }}</span>
        </div>
        <div>
          <span class="label">{{ $t("pages.wording.sendingtime") }}</span>
          <span>{{ progress.datetime }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ApprovalProgressIndicator",
  data() {
    return {}
  },
  props: {
    progressData: Array,
  },
}
</script>

<style scoped>
#ApprovalProgressIndicator ul {
  margin: 0;
  list-style: none;
  width: 100%;
  padding-left: 0;
}

#ApprovalProgressIndicator li {
  position: relative;
  display: grid;
  row-gap: 4px;
  color: var(--balck);
  width: 100%;
  margin: 0;
  padding: 12px 0 12px 44px;
  box-sizing: border-box;
  font-size: var(--content-font-size);
  line-height: var(--content-line-height);
}

#ApprovalProgressIndicator li .state {
  font-weight: 700;
}

/* dot of progress indicator */
#ApprovalProgressIndicator li:before {
  content: "";
  position: absolute;
  width: 12px;
  height: 12px;
  line-height: 22px;
  border: 2px solid var(--blue500);
  background: var(--white);
  border-radius: 100%;
  text-align: center;
  z-index: 1;
  top: 50%;
  left: 9px;
}

#ApprovalProgressIndicator li.active:before {
  background: var(--blue500);
}

#ApprovalProgressIndicator li:after {
  content: "";
  position: absolute;
  width: 2px;
  height: 100%;
  display: block;
  left: 14px;
  margin-left: 0;
  background: var(--blue500);
}

#ApprovalProgressIndicator li:first-child:after {
  height: 50%;
  bottom: 0;
}

#ApprovalProgressIndicator li:last-child:after {
  height: 50%;
}

#ApprovalProgressIndicator li .label {
  margin-right: 4px;
}
</style>
